import { useDispatch } from 'react-redux';
import { DealService } from '../services';
import { getSessionIdCookie, setSessionIdCookie } from '@utils/Session.utils';
import { useCarDetailsDuck } from '@hooks/useCarDetailsDuck';
import UIDuck from '../redux/commonDucks/ui.duck';
import { ModalVersion, SESSION_COOKIE_NAME } from '../constants/main';
import { useRouter } from 'next/router';
import { useFeatureSwitchEnabled } from '@hooks/useFeatureSwitchEnabled';
import { FEATURES_LIST } from '../context/featureSwitchApp';
import { ModalSessionChangeVersion } from '@components/Modal/ModalSessionChange/ModalSessionChangeTemplate';
import { useFeatureSwitch } from '@hooks/useFeatureSwitch';
import { getRedirectDestinationOnActivateDeal } from '@utils/Deal.utils';

const useSessionChangeListener = () => {
    const dispatch = useDispatch();

    const router = useRouter();

    const { currentDeal, carDetails } = useCarDetailsDuck();

    const { isStockSummaryEnabled, isMTOSummaryEnabled } = useFeatureSwitch();

    const isSessionChangeCheckEnabled = useFeatureSwitchEnabled(
        FEATURES_LIST.FEATURE_SWITCH_CHECK_SESSION_CHANGE_ENABLED
    );

    const handleContinueButtonChange = async (continueToBasketPage: any, continueOnError: boolean = true) => {
        try {
            const { data } = await DealService.currentDeal(getSessionIdCookie());

            console.log('PREVIOUS', data.fullProductConfiguration.engineGearboxFuelSlug);
            console.log('NEW', carDetails.engineGearboxFuelSlug);

            if (isSessionChangeCheckEnabled && data?.token) {
                dispatch(
                    UIDuck.openModal({
                        data: {
                            continueWithNewConfiguration: () => {
                                continueToBasketPage?.();
                            },
                            changeWithPreviousConfiguration: async () => {
                                const isSummaryEnabled = data?.fullProductConfiguration.stock
                                    ? isStockSummaryEnabled
                                    : isMTOSummaryEnabled;
                                const redirectRoute = getRedirectDestinationOnActivateDeal(data, isSummaryEnabled);
                                if (redirectRoute) router.push(redirectRoute);
                            },
                            previousConfiguration: data,
                            version: ModalSessionChangeVersion.CONTINUE_WITH_NEW_OR_PREVIOUS,
                        },
                        modalType: UIDuck.MODAL_TYPES.SESSION_CHANGE,
                        modalVersion: ModalVersion.v2,
                        modalProperties: { centerModeOnDesktop: true },
                    })
                );

                return true;
            }
        } catch (error: any) {
            if (error?.response?.status === 404 && continueOnError) {
                return continueToBasketPage?.();
            }

            return false;
        }
    };

    const handleTabChange = () => {
        if (document.visibilityState === 'visible') {
            DealService.currentDeal(getSessionIdCookie()).then(({ data }) => {
                console.log('FETCH TOKEN', data?.token, data?.status);
                console.log('STATE TOKEN', currentDeal.token, currentDeal?.status);

                if (
                    isSessionChangeCheckEnabled &&
                    ((data?.token && currentDeal?.token && data?.token !== currentDeal?.token) ||
                        (data?.status && currentDeal?.status && data?.status !== currentDeal?.status))
                ) {
                    dispatch(
                        UIDuck.openModal({
                            data: {
                                continueWithNewConfiguration: () => {
                                    router.reload();
                                },
                                newConfiguration: data,
                                version: ModalSessionChangeVersion.CONTINUE_WITH_NEW_OR_HOMEPAGE,
                            },
                            modalType: UIDuck.MODAL_TYPES.SESSION_CHANGE,
                            modalVersion: ModalVersion.v2,
                            modalProperties: { centerModeOnDesktop: true },
                        })
                    );
                }
            });
        }
    };

    return { handleTabChange, handleContinueButtonChange };
};

export default useSessionChangeListener;
